<template>
    <div class="page-statistics">
        <crumbs></crumbs>
        <el-button type="primary" icon="el-icon-plus" class="add-btn" @click="handleAddEdit('add')">新增</el-button>
        <div class="filters-container">
            <div class="filter-line">
                <div class="title-name">学校名称：</div>
                <div class="filter-ipt">
                    <el-input prefix-icon="el-icon-search" v-model="filters.schoolName" placeholder="搜索学校名称" class="no-border" @change="initData" clearable />
                </div>
            </div>
            <CheckedSelect v-model="filters.productIdList" :options="[{id:'',name:'全部'}, ...productList]" label="产品分类" :props="{multi:true}" @change="initData" />
            <CheckedSelect v-model="filters.saleUserId" :options="salePersonOption" label="销售人员" @change="initData" />
            <CheckedSelect v-model="filters.state" :options="stateOption" label="产品状态" @change="initData" />
            <CheckedSelect v-model="filters.payIntention" :options="payIntentionOption" label="付费意向" @change="initData" />
        </div>
        <div class="main-content">
            <div class="item-box" v-for="item in dataList" :key="item.id">
                <div class="more-menu">
                    <el-popover placement="bottom" :trigger="$utils.isMobile() ? 'manual' : 'hover'" popper-class="my-pop">
                        <ul class="corner-operation">
                            <li @click="handleAddEdit('edit', item)" v-if="!$utils.isMobile()">编辑</li>
                            <li @click="handleDelete(item)">删除</li>
                        </ul>
                        <i slot="reference" class="iconfont icon-gengduo more-icon"></i>
                    </el-popover>
                </div>
                <div class="head" @click="handleAddEdit('preview', item)">
                    <img src="@/assets/image/requirement/icon-require.png" class="avatar">
                    <span class="ell">{{ item.title }}</span>
                    <!-- 负责销售 -->
                    <div class="right-person">
                        <img src="@/assets/image/icon-person.svg" alt="" />
                        <span class="value">{{ item.saleUserName }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label-box">
                        <span class="label">来源学校</span>
                        <span class="value">{{ item.schoolName }}</span>
                    </div>
                    <div class="label-box">
                        <span class="label">所属产品</span>
                        <span class="value">{{ item.productName }}</span>
                    </div>
                    <div class="label-box">
                        <span class="label">提出人</span>
                        <span class="value">{{ item.submitUser }}</span>
                    </div>
                    <div class="label-box">
                        <span class="label">提出日期</span>
                        <span class="value">{{ item.submitDate }}</span>
                    </div>
                    <div class="label-box" v-if="item.score > 0">
                        <span class="label">销售评价</span>
                        <span class="value">
                            <img :src="require(`@/assets/image/requirement/icon-score${item.score}.png`)" class="score">
                        </span>
                    </div>
                </div>
                <el-steps :active="item.node - 1" finish-status="success" align-center>
                    <el-step title="提出需求"></el-step>
                    <el-step :title="item.stateName === '未通过' ? '会议未通过' : '会议评估'" :class="{'red': item.stateName === '未通过'}"></el-step>
                    <el-step title="功能开发"></el-step>
                    <el-step title="销售评价"></el-step>
                    <el-step title="完成"></el-step>
                </el-steps>
            </div>
        </div>
        <pagination v-show="total" :total="total" :page.sync="filters.currentPage" :limit.sync="filters.limit" :pageSizes="[6, 12, 24, 48]" @pagination="initData" style="margin-top: 30px;" />
        <!-- 新增编辑 -->
        <addedit-dialog :visible="addEditVisible" :editItem="editItem" :type="addEditType" @close="closeDialog" />
        <!-- 删除 -->
        <delConfirm :visible.sync="delDrawer" title="删除需求" :id="deleteId" :sname="deleteName" @change="initData" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { findRequirementCardList } from '@/api/requirement'

export default {
    components: {
        addeditDialog: () => import('./addEdit/index.vue'),
        delConfirm: () => import("@/views/customer/components/delConfirm.vue")
    },
    data() {
        return {
            filters: {
                schoolName: '', // 学校名称
                productIdList: [], // 产品分类
                saleUserId: '', // 销售人员
                state: '', // 产品状态
                payIntention: '', // 付费意向
                currentPage: 1,
                limit: 6
            },
            stateOption: [
                { id: '', name: '全部' },
                { id: 1, name: '创建中' },
                { id: 2, name: '会议评估中' },
                { id: 3, name: '开发中' },
                { id: 4, name: '销售评价中' },
                { id: 5, name: '已完成' },
                { id: 6, name: '未通过' }
            ],
            payIntentionOption: [
                { id: '', name: '全部' },
                { id: 1, name: '有' },
                { id: 0, name: '无' },
            ],
            dataList: [],
            total: 0,
            // 新增/编辑
            addEditVisible: false,
            editItem: null,
            addEditType: '',
            // 删除
            delDrawer: false,
            deleteId: null,
            deleteName: null,
        }
    },
    computed: {
        ...mapState(["productList", "salePersonOption"]),
    },
    created() {
        this.initData();
    },
    methods: {
        // 查询数据列表
        initData() {
            findRequirementCardList(this.filters).then(res => {
                this.dataList = res.data;
                this.total = res.count;
            }).catch(err => {
                this.dataList = [];
                this.total = 0;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 新增编辑
        handleAddEdit(type, item = null) {
            this.addEditType = type;
            this.addEditVisible = true;
            this.editItem = item;
        },
        // 关闭新增编辑弹窗
        closeDialog() {
            this.addEditVisible = false;
            this.initData();
        },
        // 删除
        handleDelete(item) {
            this.deleteId = item.id;
            this.deleteName = item.title;
            this.delDrawer = true;
        },
    }
}
</script>

<style lang="scss" scoped>
.page-statistics {
    position: relative;
    min-width: 1400px;
    width: 80%;
    margin: 0 auto;
    padding-top: $pc-header-height;
    min-height: calc(100vh - #{$pc-header-height});
    padding-bottom: 4rem;
    .add-btn {
        position: absolute;
        right: 0;
        top: calc(20px + #{$pc-header-height});
    }
    .filters-container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding: 20px;
        margin-bottom: 20px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
        /deep/ .filter-line {
            display: flex;
            &:not(:last-of-type) {
                margin-bottom: 8px;
            }
            .title-name {
                min-width: 6rem;
                padding-top: 5px;
                white-space: nowrap;
            }
            .filter-ipt {
                width: 40%;
                border-radius: 1.6rem;
                box-shadow: 0 0.06667rem 0.4rem 0.06667rem rgba(0, 0, 0, 0.1);
                overflow: hidden;
                padding: 0 0.6rem;
                > .el-input {
                    .el-input__inner {
                        height: 2.2rem;
                        line-height: 2.2rem;
                    }
                    .el-input__prefix {
                        left: 0.2rem;
                        .el-input__icon {
                            line-height: 2.2rem;
                        }
                    }
                }
            }
        }
    }
    .main-content {
        display: flex;
        flex-wrap: wrap;
        gap: 21px 18px;
        .item-box {
            position: relative;
            display: flex;
            flex-direction: column;
            background-color: #fff;
            border-radius: 12px;
            box-shadow: 0px 1px 0.75rem 1px rgba(4, 32, 93, 0.09);
            padding: 1.2rem;
            min-width: 20rem;
            box-sizing: border-box;
            width: calc(100% / 3 - 12px);
            .more-menu {
                position: absolute;
                right: 1rem;
                top: 0.8rem;
                .more-icon {
                    font-size: 1.8rem;
                    cursor: pointer;
                }
            }
            .head {
                display: flex;
                gap: 8px;
                padding-bottom: 0.6rem;
                margin-bottom: 0.8rem;
                border-bottom: 2px dashed #eeeeee;
                cursor: pointer;
                .avatar {
                    width: 24px;
                    height: 24px;
                }
                .ell {
                    color: $primary-btn-color;
                    font-size: 1.1rem;
                    font-weight: 550;
                    max-width: calc(100% - 2.4rem - 32px - 80px);
                }
                .right-person {
                    margin-right: 36px;
                    margin-left: auto;
                    img {
                        width: 1rem;
                        margin-right: 6px;
                        vertical-align: -3px;
                    }
                }
            }
            .content {
                display: flex;
                flex-wrap: wrap;
                gap: 16px;
                margin-bottom: 20px;
                .label-box {
                    width: calc(50% - 8px);
                    .label {
                        display: inline-block;
                        width: 75px;
                        // text-align: right;
                        white-space: nowrap;
                        color: #acacac;
                    }
                    .score {
                        height: 1.1rem;
                        vertical-align: -3px;
                    }
                }
            }
            /deep/ .el-steps {
                margin-top: auto;
                margin-bottom: 0;
                .el-step {
                    .el-step__head {
                        .el-step__line-inner {
                            border-color: #0051e2;
                        }
                        .el-step__icon {
                            width: 20px;
                            height: 20px;
                            .el-step__icon-inner {
                                font-size: 13px;
                                font-weight: 400;
                            }
                        }
                    }
                    .el-step__head.is-success,
                    .el-step__head.is-process {
                        .el-step__icon {
                            background-color: #0051e2;
                            border-color: #0051e2;
                            .el-step__icon-inner {
                                color: #fff;
                            }
                        }
                    }
                    .el-step__head.is-success {
                        .el-step__line-inner {
                            width: 100% !important;
                            border-width: 1px !important;
                            transition-delay: 150ms !important;
                        }
                    }
                    .el-step__main {
                        .el-step__title.is-success,
                        .el-step__title.is-process {
                            color: #10345e;
                        }
                        .el-step__title {
                            font-weight: 400;
                            font-size: 0.8rem;
                        }
                    }
                    &.red {
                        .el-step__head .el-step__icon {
                            background-color: #ed0505;
                            border-color: #ed0505;
                        }
                        .el-step__main .el-step__title {
                            color: #ed0505;
                        }
                    }
                }
            }
        }
    }
}
</style>